/**
 * A Bought Out company's successor, in words (decision 7690; T3141): the
 * banner's two sentences, the History lines on both companies and the server's
 * refusals, spread into the one lookup in `strings.ts`. 🔨 This file imports
 * nothing, because the lookup imports it.
 */
export const COMPANY_SUCCESSOR_STRINGS = {
  'succession.boughtOutBy': 'Bought out by',
  'succession.formerly': 'Formerly',
  'succession.formerlyMany': 'Formerly {count} companies',
  'succession.history.boughtOut': 'Bought out by {successor} on {date}, set by {person}',
  'succession.history.tookOver': 'Took over {predecessor} on {date}, set by {person}',
  'history.audit.boughtOut': 'Bought out',
  'history.audit.tookOver': 'Took over',
  'succession.refusal.none': 'Name the company that bought {name}: pick one or type a new name.',
  'succession.refusal.both': 'Name the company that bought {name} once: pick one or type a new name, not both.',
  'succession.refusal.self': '{name} cannot be its own successor; name the company that bought it.',
  'succession.refusal.missing': 'No company {id} was found to name as the successor.',
  'succession.refusal.trashed': '{successor} is in the Trash Bin; restore it or name another company.',
  'succession.refusal.boughtOut': '{successor} is itself Bought Out; name the company that bought it.',
  'succession.refusal.notBoughtOut': 'Only a Bought Out company has a successor; set the status to Bought Out or leave the successor empty.',
} as const;
